import { render, staticRenderFns } from "./ReviewUpLimitTier.vue?vue&type=template&id=071532a8"
import script from "./ReviewUpLimitTier.vue?vue&type=script&lang=js"
export * from "./ReviewUpLimitTier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports